import React, { useState } from 'react';
import { BoxContainer, FormSection } from '../../../components';
import BulkEmailInsuredsTable from './BulkEmailInsuredsTable';
import BulkEmailInsuredsFilters from './BulkEmailInsuredsFilters';
import { TablePagination } from '../../../components/tables';
import useListDocumentInsureds from '../../bulkDownloadDocuments/hooks/useListDocumentInsureds';

export default function BulkEmailInsuredsSelection({ formik, policyId, clientId }) {
  const { activeOnDate, insuredIdsFilteredByDocs: insuredIds } = formik?.values;

  const [insuredsFilter, setInsuredsFilter] = useState({
    policyId: policyId,
    clientId: clientId,
    status: 'ACTIVE',
    ordering: 'LAST_NAME',
    activeOn: !!activeOnDate ? activeOnDate : null,
    ids: insuredIds
  });

  const { insureds, loading, error, paginationProps, loadFirstPage } = useListDocumentInsureds({
    filters: insuredsFilter
  });

  const onChange = filters => {
    setInsuredsFilter({ ...filters });
    loadFirstPage({ ...insuredsFilter, ...filters });
  };

  return (
    <>
      <FormSection title="Select Recipients">
        <BulkEmailInsuredsFilters defaults={insuredsFilter} onChange={onChange} filterValue={insuredsFilter} />
        <BoxContainer>
          <BulkEmailInsuredsTable formik={formik} insureds={insureds} loading={loading} error={error} />
        </BoxContainer>
        <TablePagination {...paginationProps} loading={loading} />
      </FormSection>
    </>
  );
}
